/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-20 14:44:35
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-04-01 20:12:51
 * @FilePath: /designcenter/src/router/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory, RouteRecordRaw, type RouteLocationRaw } from 'vue-router'

// import { initProject } from '@/api/modules/project'
// import {useProjectStore} from '@/store/project'
// import { useUserStore } from '@/store/user'
// import { storeToRefs } from 'pinia'
// import { handleFsLink } from '@/utils/'

import Layout from '@/layout/index.vue'

const SITE_ROUTE_PREFIX = '/:site([a-z]{2}|[a-z]{2}-[a-z]{2})?'

const routes: RouteRecordRaw[] = [
  {
    path: SITE_ROUTE_PREFIX,
    component: Layout,
    redirect: to => ({ name: 'DesignCenter', params: { site: to.params.site } }),
    children: [
      {
        path: 'design-center',
        name: 'DesignCenter',
        meta: { title: '设计中心', menuId: 'design-center' },
        component: () => import('../views/designCenter/index.vue'),
      },
      {
        path: 'product-catalog',
        name: 'ProductCatalog',
        meta: { title: '产品清单', menuId: 'ProductCatalog' },
        component: () => import('../views/product-catalog/index.vue'),
      },
      {
        path: 'project',
        name: 'Project',
        meta: { title: '项目管理', menuId: 'ProjectManage' },
        component: () => import('../views/project/index.vue'),
      },
      {
        path: 'template-manage',
        name: 'TemplateManage',
        meta: { title: '模板管理' },
        component: () => import('../views/templateManage/index.vue'),
      },
      {
        path: 'template-config',
        name: 'TemplateConfig',
        meta: { title: '模板配置' },
        component: () => import('../views/templateManage/components/TemplateConfig/index.vue'),
      },
      {
        path: 'operation-manual',
        name: 'OperationManual',
        component: () => import('@/views/operation-manual/index.vue'),
        meta: {
          layout: 'manual', // 使用特殊布局
          public: true, // 公共页面，无需登录，不发起鉴权类接口请求
        },
      },
    ],
  },
  {
    path: `${SITE_ROUTE_PREFIX}/pdf-export`,
    name: 'PdfExport',
    meta: { title: 'PDF导出' },
    component: () => import('../views/pdf-export/index.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/design-center',
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

let allowSitePrefixChange = false

router.beforeEach(to => {
  if (allowSitePrefixChange || to.params.site) return true

  const currentSite = router.currentRoute.value.params.site
  if (typeof currentSite !== 'string' || !currentSite) return true

  return {
    path: `/${currentSite}${to.path}`,
    query: to.query,
    hash: to.hash,
  }
})

export const replaceRouteSite = async (site: string) => {
  const currentRoute = router.currentRoute.value
  const params = { ...currentRoute.params, site }

  const target: RouteLocationRaw = currentRoute.name
    ? {
        name: currentRoute.name,
        params,
        query: currentRoute.query,
        hash: currentRoute.hash,
        replace: true,
      }
    : currentRoute.fullPath

  allowSitePrefixChange = true
  try {
    await router.replace(target)
  } finally {
    allowSitePrefixChange = false
  }
}

export default router
